var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSapStatsSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100.142%",
    x2: "50%",
    y2: ".142%",
    id: "uoq3am9qwb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215EBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB1EF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.999%",
    y1: "100.142%",
    x2: "49.999%",
    y2: ".142%",
    id: "ojfmm167ue"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215EBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB1EF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100.142%",
    x2: "50%",
    y2: ".142%",
    id: "f32ehk8uzh"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215EBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB1EF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.76 0 0 2.387c.227.086.49.136.768.136.273 0 .528-.048.752-.128L.775 0H.76z",
    id: "6igw2xkk3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v1.925h.528c.704 0 1.265-.233 1.265-.973C1.793.233 1.233 0 .528 0H0z",
    id: "2ymwb5ukfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v12h12.303L24.344 0H0zm3.066 8.182c.351-.007.606-.07.772-.242a.548.548 0 0 0 .157-.372c.006-.38-.537-.56-1.201-.764-.54-.167-1.152-.394-1.63-.743-.567-.415-.836-.935-.823-1.667a2.012 2.012 0 0 1 .574-1.393C1.44 2.46 2.29 2.13 3.31 2.13h.006c.874.001 1.942.248 2.715.64l-.835 1.445c-.844-.407-1.27-.445-1.753-.471-.716-.04-1.08.218-1.084.492-.006.337.677.64 1.324.847.978.31 2.22.724 2.41 1.92l1.788-4.747h2.075l2.094 5.677V2.255h2.396c2.29 0 3.367.814 3.367 2.587 0 1.592-1.109 2.541-2.98 2.541h-.774v2.293h-3.55l-.352-1.096c-.375.122-.8.19-1.249.19-.461 0-.896-.072-1.28-.2l-.365 1.106H5.088l.24-.64c-.028.025-.058.052-.087.075-.544.435-1.221.675-2.063.69h-.125a5.553 5.553 0 0 1-2.712-.718l.74-1.465c.758.446 1.249.565 1.874.565l.11-.001z",
    id: "5vp2rlbhxg"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.6 10.592)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "vlg2njoiec",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6igw2xkk3a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.76 0 0 2.387c.227.086.49.136.768.136.273 0 .528-.048.752-.128L.775 0H.76z",
    fill: "url(#uoq3am9qwb)",
    mask: "url(#vlg2njoiec)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.52 9.817)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3kv8watu7f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2ymwb5ukfd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v1.925h.528c.704 0 1.265-.233 1.265-.973C1.793.233 1.233 0 .528 0H0z",
    fill: "url(#ojfmm167ue)",
    mask: "url(#3kv8watu7f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.46 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gdx4jmq9ti",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5vp2rlbhxg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v12h12.303L24.344 0H0zm3.066 8.182c.351-.007.606-.07.772-.242a.548.548 0 0 0 .157-.372c.006-.38-.537-.56-1.201-.764-.54-.167-1.152-.394-1.63-.743-.567-.415-.836-.935-.823-1.667a2.012 2.012 0 0 1 .574-1.393C1.44 2.46 2.29 2.13 3.31 2.13h.006c.874.001 1.942.248 2.715.64l-.835 1.445c-.844-.407-1.27-.445-1.753-.471-.716-.04-1.08.218-1.084.492-.006.337.677.64 1.324.847.978.31 2.22.724 2.41 1.92l1.788-4.747h2.075l2.094 5.677V2.255h2.396c2.29 0 3.367.814 3.367 2.587 0 1.592-1.109 2.541-2.98 2.541h-.774v2.293h-3.55l-.352-1.096c-.375.122-.8.19-1.249.19-.461 0-.896-.072-1.28-.2l-.365 1.106H5.088l.24-.64c-.028.025-.058.052-.087.075-.544.435-1.221.675-2.063.69h-.125a5.553 5.553 0 0 1-2.712-.718l.74-1.465c.758.446 1.249.565 1.874.565l.11-.001z",
    fill: "url(#f32ehk8uzh)",
    mask: "url(#gdx4jmq9ti)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapStatsSection);
export default __webpack_public_path__ + "static/media/sap-stats-section.1073b60e.svg";
export { ForwardRef as ReactComponent };